import {BuildPageTabNamesEnum} from '../../../../../../types'

export enum AdditionalJobDetailsTabs {
  GAME = 'game',
}

export const additionalJobDetailsTabs = {
  [AdditionalJobDetailsTabs.GAME]: {id: AdditionalJobDetailsTabs.GAME, title: '🎮 Take a break'},
}

export const supportedTabs = [
  BuildPageTabNamesEnum.LOG,
  BuildPageTabNamesEnum.CHANGES,
  BuildPageTabNamesEnum.TESTS,
  BuildPageTabNamesEnum.ARTIFACTS,
  AdditionalJobDetailsTabs.GAME,
]
